import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = {
  key: 0,
  class: "padw10"
}
const _hoisted_3 = { class: "grey fs12 pad3" }
const _hoisted_4 = {
  key: 0,
  class: "fs16"
}
const _hoisted_5 = { class: "fs20 fw600" }
const _hoisted_6 = { class: "fs20" }
const _hoisted_7 = {
  key: 1,
  class: "padw10"
}
const _hoisted_8 = { class: "grey fs12 pad3" }
const _hoisted_9 = {
  key: 0,
  class: "fs16"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.log && _ctx.users)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.log.large_category == `access_admin`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.createdAt), 1),
              (_ctx.user)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.name), 1),
                    _createTextVNode("さんがログインしました。"),
                    _createElementVNode("span", _hoisted_6, "（" + _toDisplayString(_ctx.log.ip_address) + "）", 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.createdAt), 1),
              (_ctx.user)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.htmlText(_ctx.log, _ctx.user)
                    }, null, 8, _hoisted_10)
                  ]))
                : _createCommentVNode("", true)
            ])),
        _hoisted_11
      ]))
    : _createCommentVNode("", true)
}